"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyQuotationProfile = void 0;
function makeEmptyQuotationProfile() {
    return {
        id: 0,
        description: '',
        type: '',
        avoidInspection: false,
        typeOfMoney: '',
    };
}
exports.makeEmptyQuotationProfile = makeEmptyQuotationProfile;
//# sourceMappingURL=QuotationProfile.js.map